<template>
<div id="DPEBBHome" >
<Subtitle  v-bind:ServiceID="this.AppServiceID" v-bind:MainPage="true">
   <template v-slot:header>
    <i class="fas fa-igloo"></i><b>Administration Home:</b>
  </template> 
</Subtitle>
<Card>
<CardBody>
<p>Any personal health information accessed through Administration application is the property of the Government of Saskatchewan. Access to the contents of this site except by agencies <b>AUTHORIZED BY SASKATCHEWAN HEALTH IN WRITING</b> or their authorized employees is strictly prohibited. All transactions are monitored, logged and reviewed.
</p>
<TileNote>
<strong>Please Note:</strong> Legal action will be taken against any person accessing information without prior approval from Saskatchewan Health AND THOSE WHO UTILIZE THE INFORMATION FOR UNAUTHORIZED OR UNLAWFUL PURPOSES.
</TileNote>
<!-- <button type="button" v-if="AllAppLevel" v-on:click="Go" class="btn btn-primary login_btn"> Back To Main Menu</button> -->
</CardBody>
</Card>
</div>
</template>
<script>
import {mapGetters} from 'vuex'
import axios from 'axios'
import Subtitle from '@/Common/Default/SubTitle.vue'; 
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
export default  {
  data: function () {
    return {
        AppServiceID :6,
        
         // menuitems:""
        }
    },
    components: {

            Card,
            CardBody,
            TileNote,
            Subtitle
        },
    methods: {
        Go(){
            this.$router.push('/DPEBB/MainHome')
        }
    },
    computed:{
         UserName(){
            return !this.$store.getters.GetCurrentUser ? false : this.$store.getters.GetCurrentUser;
        },
         AllAppLevel(){
            return this.$store.getters.GetAllApplevel;
          }
    },
    created: function() {
            this.$emit('update:layout', LayoutDefault);
    },
    beforeCreate: function() {
        //alert('At Dental ')
         this.$store.dispatch('AddServiceID',this.$store.getters.GetDPEBBServiceID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetDPEBBServiceID);
            //this.$store.dispatch('SetBuildMenu');
    },
}
</script>
<style>

</style>
